import axios from 'axios';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import React, { useEffect } from 'react';

interface DashOpenProps {
  dashboardId: string;
  dashboardLabel: string;
  onClose: () => void;
}

const DashOpen: React.FC<DashOpenProps> = ({ dashboardId, dashboardLabel, onClose }) => {
  useEffect(() => {
    async function embed() {
      try {
        const loginRes = await axios.post(
          `${BASE_API_URL_SUPERSET}/login`,
          {
            username: 'admin',
            password: 'Super2025@',
            provider: 'db',
            refresh: true,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );

        const accessToken = loginRes.data.access_token;

        const guestTokenRes = await axios.post(
          `${BASE_API_URL_SUPERSET}/guest_token/`,
          {
            resources: [{ type: 'dashboard', id: dashboardId }],
            rls: [],
            user: { username: '', first_name: '', last_name: '' },
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const guestToken = guestTokenRes.data.token;

        const mountPoint = document.getElementById('superset-container');
        if (!mountPoint) {
          console.error('Mount point not found');
          return;
        }

        mountPoint.innerHTML = '';

        embedDashboard({
          id: dashboardId,
          supersetDomain: BASE_URL_SUPERSET,
          mountPoint,
          fetchGuestToken: () => guestToken,
          dashboardUiConfig: {
            hideTitle: true,
            filters: { expanded: false },
            urlParams: { standalone: true },
          },
        });

        setTimeout(() => {
          const iframe = mountPoint.querySelector('iframe') as HTMLIFrameElement | null;
          if (iframe) {
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
          }
        }, 500);
      } catch (error) {
        console.error('Error embedding dashboard:', error);
      }
    }

    embed();
  }, [dashboardId]);

  return (
    <Dialog
      onClose={onClose}
      open
      fullWidth
      maxWidth="xl"
      PaperProps={{
        sx: {
          height: '100vh',
          maxHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" p={1}>
        <Typography variant="h6" fontWeight="bold" color="primary">
          {dashboardLabel}
        </Typography>
        <Button variant="contained" onClick={onClose} color="error" size="small">
          CHIUDI
        </Button>
      </Box>

      <DialogContent
        sx={{
          flexGrow: 1,
          padding: 0,
          overflow: 'hidden', // no scroll here
          display: 'flex',
        }}
      >
        <div id="superset-container" style={{ width: '100%', height: '100%' }} />
      </DialogContent>
    </Dialog>
  );
};

export default DashOpen;
